import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Camera, ConfigCamera } from '@classes/camera/camera';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { CamerasService } from '@services/cameras/cameras.service';

export interface DialogData {
  camera: Camera;
}

@Component({
  selector: 'app-smartparking-cameras-config',
  templateUrl: './smartparking-cameras-config.component.html',
  styleUrls: ['./smartparking-cameras-config.component.scss']
})
export class SmartparkingCamerasConfigComponent implements OnInit {

  faPen = faPen;
  configCamera: ConfigCamera;

  constructor(
    public dialogRef: MatDialogRef<SmartparkingCamerasConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private cameraService: CamerasService
  ) { }

  ngOnInit(): void {
    this.getConfigCamera();
  }

  private getConfigCamera(): void {
    this.cameraService.getConfigCamera(this.data.camera.id).subscribe(res => {
      this.configCamera = res;
    });
  }

}
